module.exports = __webpack_public_path__ + "static/img/heals_app_qr_code.0482c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heals_app_qr_code.png
// module id = 2Gso
// module chunks = 1